<script>
import axios from 'axios'
import moment from 'moment/moment'
const _ = require('lodash')
export default {
  name: 'ExecutionDocuments',
  computed: {
    moment() {
      return moment
    }
  },

  props: {
    execution: {
      type: Object,
      required: true
    }
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.current.page ||
            this.pagination.rowsPerPage !== this.current.rowsPerPage ||
            this.pagination.sortBy !== this.current.sortBy ||
            this.pagination.descending !== this.current.descending
          ) {
            this.current.page = this.pagination.page
            this.current.rowsPerPage = this.pagination.rowsPerPage
            this.current.sortBy = this.pagination.sortBy
            this.current.descending = this.pagination.descending
            this.getItems()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  data: () => ({
    headerDocuments: [
      {
        text: 'External Document Id / Internal Id',
        align: 'left',
        value: 'hexId',
        sortable: false
      },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Name', value: 'documentName' },
      { text: 'Action', value: 'documentAction' },
      {
        text: 'Created By / Execution Id responsible ',
        value: 'doneBy'
      }
    ],
    documents: [],
    documentsLoading: false,
    searchDocuments: '',
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false,
      totalItems: 0
    },
    current: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false
    },
    rowsPerPageItems: [5, 10, 25]
  }),

  mounted() {
    this.getItems()
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getUrlParams() {
      let urlParams = ''
      //fill URL Params from current structure

      urlParams += `&page=${this.current.page}`
      urlParams += `&size=${this.current.rowsPerPage}`
      if (this.current.sortBy) {
        urlParams += `&sort=${this.current.sortBy}`
        if (this.current.descending) {
          urlParams += `,desc`
        }
      }
      if (this.searchDocuments) {
        urlParams += `&documentId=${this.searchDocuments}`
      }
      return urlParams
    },
    getItems() {
      this.documentsLoading = true
      const urlParams = this.getUrlParams()
      axios
        .get(
          `/api/v1/automationDocuments?executionId=${this.execution.hexId}${urlParams}`
        )
        .then(response => {
          if (response.data._embedded) {
            this.pagination.totalItems = response.data.page.totalElements
            this.documents = response.data._embedded.automationDocuments
            this.documents.forEach(document => {
              document.doneBy = 'Current'
            })
            this.documentsLoading = false
          } else {
            this.pagination.totalItems = 0
            this.documents = []
            this.documentsLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.documentsLoading = false
        })

      this.documentsLoading = true
      axios
        .get(
          `/api/v1/automationDocuments?parentExecutionId=${this.execution.hexId}${urlParams}`
        )
        .then(response => {
          let childDocuments = response.data._embedded.automationDocuments
          childDocuments.forEach(document => {
            document.doneBy = 'Child'
          })
          this.documents = this.documents.concat(childDocuments)
          this.documentsLoading = false
        })
        .catch(error => {
          console.log(error)
          this.documentsLoading = false
        })
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3"
        >Documents created as part of this workflow or a child workflow
        execution
      </span>
      <v-spacer />
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field
            v-model="searchDocuments"
            color="secondary"
            label="Search by External Document Id"
            xs5
          >
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="searchDocuments = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getItems()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headerDocuments"
        :items="documents"
        :loading="documentsLoading"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="pagination.totalItems"
        item-key="hexId"
      >
        <v-progress-linear slot="progress" color="accent" indeterminate />
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">
              <div class="body-2 font-weight-bold orange--text">
                {{ props.item.documentId }}
              </div>
              <div class="caption">
                {{ props.item.hexId }}
              </div>
            </td>

            <td class="text-xs-left">
              {{
                props.item.createdAt
                  ? moment(props.item.createdAt)
                      .utc()
                      .local()
                      .format('DD MMM YYYY hh:mm:ss a')
                  : ''
              }}
            </td>
            <td class="text-xs-left">
              <div class=" body-1 font-weight-bold">
                {{ format(props.item.documentName) }}
              </div>
            </td>
            <td class="text-xs-left">
              <div class=" body-1 font-weight-bold">
                {{ format(props.item.documentAction) }}
              </div>
            </td>
            <td class="text-xs-left">
              <div class="body-2 font-weight-bold orange--text">
                {{ format(props.item.doneBy) }} Workflow
              </div>
              <div class="caption">
                {{
                  props.item.doneBy === 'Current'
                    ? props.item.executionId
                    : props.item.parentExecutionId
                }}
              </div>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <v-alert :value="true" color="warning" icon="warning">
            No Documents created!
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
